import { defineStore } from 'pinia';
import { useDeveloperSettingsStore } from './developer-settings';
import {
    defaultCommwebServiceBaseUrl, defaultLegacyCommwebServiceBaseUrl, defaultLedsServiceBaseUrl
} from '@/config/service-constants';

import type {
    AppStoreState,
    SiteConfiguration,
} from '@/types';

export const useAppStore = defineStore('app', {
    state: () => {
        const state: AppStoreState = {
            featureFlags: [],
            siteConfiguration: null
        };
        return state;
    },
    getters: {
        serviceBaseUrls() {
            const developerSettingsStore = useDeveloperSettingsStore();
            return {
                commwebServiceBaseUrl: developerSettingsStore.commwebServiceBaseUrl ?? defaultCommwebServiceBaseUrl,
                ledsServiceBaseUrl: developerSettingsStore.ledsServiceBaseUrl ?? defaultLedsServiceBaseUrl,
                legacyCommwebServiceBaseUrl:
                    developerSettingsStore.legacyCommwebServiceBaseUrl ?? defaultLegacyCommwebServiceBaseUrl
            };
        }
    },
    actions: {
        /**
         * Should be called before the Vue app is mounted.
         */
        initialize() {
            const developerSettingsStore = useDeveloperSettingsStore();
            developerSettingsStore.initialize();
        },
        setFeatureFlags(featureFlags: string[]) {
            this.featureFlags = featureFlags;
        },
        setSiteConfiguration(siteConfiguration: SiteConfiguration | null) {
            this.siteConfiguration = siteConfiguration;
        }
    }
});

export type AppStore = ReturnType<typeof useAppStore>;
